import { Route } from '@angular/router';
import { ReportComponent } from './pages/report/report.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ReportComponent,
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
